import type { LottieComponentProps } from 'lottie-react';
import React, { Suspense } from 'react';
import { ErrorBoundary } from 'reactApp/ui/ErrorBoundary/ErrorBoundary';

const Lottie = React.lazy(() => import(/* webpackPreload: true, webpackChunkName: "lottie" */ 'lottie-react'));

const LottieWrapped = (props: LottieComponentProps) => (
    <ErrorBoundary>
        <Suspense fallback={null}>
            {/* @ts-ignore */}
            <Lottie {...props} />
        </Suspense>
    </ErrorBoundary>
);

export default LottieWrapped;
